// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonContainer = "CreditLinkageCompletion__buttonContainer__T7EXU";
export const creditLinkageCompletion = "CreditLinkageCompletion__creditLinkageCompletion__q7g4m";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitleParagraph = "CreditLinkageCompletion__subtitleParagraph__zZsFp";
export const summary = "CreditLinkageCompletion__summary__2Yu3K";